import { render, staticRenderFns } from "./ExternalAddressPage.vue?vue&type=template&id=2865618e&"
import script from "./ExternalAddressPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAddressPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports